import { combineReducers } from "redux";
import auth from "./authReducer";
import queAnsReducer from "./queAnsReducer";
import commanReducer from "./commanReducer";

const reducers = combineReducers({ auth, queAnsReducer,commanReducer});
export default reducers;
